import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CalendarIcon } from '@mui/x-date-pickers';

export default function ExpirationsHeader () {
    const { t } = useTranslation();
    return (
        <Box
            display='flex'
            alignItems='center'

            style={{ height: '58px' }}>
            <Box className='svgIcon'>
                {<CalendarIcon sx={{ color: '#F95623 !important', width: '24px', height: '24px' }} />}

            </Box>
            <Typography variant='pageHeaderTitle' className='headerText'>{t('expirations.title')}</Typography>
        </Box>
    );
}
